import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoginBox from '../components/LoginBox';

import { login, loginWithGoogle, verifyTwoFactor, resendTwoFactorCode, cancelTwoFactor } from '../actions/Login';


class LoginContainer extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGoogle = this.handleGoogle.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    handleSubmit(form) {
        this.props.dispatch(login(form));
    }

    handleGoogle(credential) {
        this.props.dispatch(loginWithGoogle(credential));
    }

    handleVerify(code) {
        return this.props.dispatch(verifyTwoFactor(code));
    }

    handleResend() {
        return this.props.dispatch(resendTwoFactorCode());
    }

    handleCancel() {
        this.props.dispatch(cancelTwoFactor());
    }

    render() {
        return (
            <LoginBox
                onSubmit={this.handleSubmit}
                onGoogle={this.handleGoogle}
                twoFactor={this.props.authentication.twoFactor}
                onVerify={this.handleVerify}
                onResend={this.handleResend}
                onCancel={this.handleCancel}
            />
        )
    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(LoginContainer);
